import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  return request.post({ url: '/user/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/mock/user/loginOut' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

// export const getSystemPermission = (): Promise<IResponse<string[]>> => {
//   return request.get({ url: '/system/permission' })
// }

export const getUserInfoApi = (): Promise<IResponse<string[]>> => {
  return request.get({ url: '/system/user_info' })
}

export const setUserConfigApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/mock/user/setConfig', data })
}

// 获取二维码
export const getQrCodeApi = (): Promise<IResponse<{ qr_code: string; second: number }>> => {
  return request.get({ url: '/user/qrcode' })
}

// 获取二维码扫描状态
export const getQrCodeStatusApi = (
  qrCode: string
): Promise<IResponse<{ status: number; login_response: UserType }>> => {
  return request.get({ url: '/user/status', params: { qr_code: qrCode } })
}
